import { UserEntity } from '../../entities'
import { api, AxiosRequestConfigWithMetadata } from '../../services/api.service'

class UserApi {
  async deleteUser(azureGuid: string) {
    const apiCall = await api.delete(`/api/user/${azureGuid}`, {
      functionName: 'user_deleteUser'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async getUserProfile(): Promise<UserEntity> {
    const apiCall = await api.get('/api/user/profile', {
      functionName: 'user_getUserProfile'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async changePasswordConfirmation() {
    const apiCall = await api.post('/api/user/change-password-confirmation', {
      functionName: 'user_changePasswordConfirmation'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }

  async changeEmailConfirmation() {
    const apiCall = await api.post('/api/user/change-email-confirmation', {
      functionName: 'user_changeEmailConfirmation'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }
}

export const userApi = new UserApi()